<mat-dialog-content class="mat-typography">
  <div class="container-fluid" id="search-container">
    <div id="background-dark" (click)="closeDialog()"></div>
    <div id="dialog-search" (click)="$event.stopPropagation()">
      <div class="p-1 d-flex align-items-center flex-column">
        <div class="search-dialog-header">
          <button mat-dialog-close  class="search-dialog-close" aria-label="Fechar busca"><i class="bi bi-x" aria-hidden="true"></i></button>
        </div>
        <div class="w-100 d-flex justify-content-center pb-4">
          <img style="width: 82px; height: 58px;" src="../../../../assets/logos/logo-yellow.svg" alt="Blukit">
        </div>
        <div style="width: 100%; padding: 0 1em; text-align: center;">
          <input #searchInput class="input-search" (focus)="onFocus()" (blur)="onInputBlur()" (keyup.enter)="onEnter($event)" (keyup)="onKeyDownEvent($event)" type="text" placeholder="Buscar Produto" aria-label="Buscar produto"/>
          <i class="bi bi-search" style="margin-left: -2em; color: var(--main-blue); font-size: 18px; cursor: pointer;" aria-hidden="true"></i>
        </div>
      </div>
      <div class="p-1 p-md-4">
        <p class="m-2" style="color: var(--main-blue)" role="status" aria-live="polite" aria-atomic="true">Produtos Encontrados</p>
        <div *ngIf="products && products.length < 1">
          <p class="text-center" role="status" aria-live="polite" aria-atomic="true">Nenhum produto encontrado!</p>
        </div>
        <div class="area-products-news" *ngIf="products">
          <a *ngFor="let product of products.slice(0, addProducts)" class="d-flex card-grid text-decoration-none" [href]="apiService.getProductCardLink(product)" [attr.target]="apiService.getProductCardTarget(product)" [attr.rel]="apiService.getProductCardRel(product)" (click)="apiService.openProductCard(product); $event.preventDefault()" mat-dialog-close >
            <div *ngIf="product" class="border p-1 d-flex justify-content-center align-itens-center align-self-start card-product-search" >
              <div style="position: absolute;">
                <div *ngIf="apiService.isTopProduct(product) && !product.fora_de_linha" class="circle bg-main-yellow best-seller" style="font-size: 9px !important; letter-spacing: 0;">TOP</div>
                <div *ngIf="!apiService.isTopProduct(product) && product.novo && !product.fora_de_linha" class="circle bg-light-blue" style="font-size: 9px !important; letter-spacing: 0;">NOVO</div>
                <div *ngIf="!apiService.isTopProduct(product) && !product.novo && !product.fora_de_linha && product.mais_vendido" class="circle bg-main-yellow best-seller" style="gap: 2px;">
                  <span class="plus" style="font-size: 12px">+</span>
                  <span class="seller"  style="font-size: 9px; letter-spacing: 0;">VENDIDO</span>
                </div>
              </div>
              <div style="width: 100%;">
                <img loading="lazy"  [ngClass]="{'opacity-25':product.fora_de_linha}"  style="width: 100%; height: 100%; object-fit: contain;" [src]="apiService.getProductImageSource(product)" [alt]="product.nome ? product.nome : product.desPro">
              </div>
            </div>
            <div class="title-search-products-cards" >
              <div class="area-search-title">
                <p class="text-uppercase">{{product.nome ? product.nome : product.desPro}}</p>
              </div>
              <p class="cod-pro-search" style="line-height: 1.3;">Ref: {{product.codPro}}
                <span *ngIf="product.fora_de_linha" style="color: var(--font-subtitle-gray) !important;" class="text-uppercase">
                  <br>
                  Indisponível
                </span>
              </p>
            </div>
          </a>
        </div>
      </div>
      <div *ngIf="products && products.length > 15 && !showedAll" class="p-5 pt-0 d-flex justify-content-center">
        <button class="btn-ver-mais-resultados" (click)="addProductsFiltered()"> VER MAIS RESULTADOS</button>
      </div>


    </div>
  </div>
</mat-dialog-content>
